export const TESTS = {
    GDPR: 'ha_gdpr_banner',
    REDESIGN_QA_SEO_TEXT: 'HA_PTA_LANDING_RedesignQASEOText',
    POLYFILL_SERVICE: 'HA_PTA_LANDING_PolyfillService',
    PROPERTY_TYPE_NAME_LISTING_CARDS: 'HA_PTA_LANDING_PropertyTypeNameListingCards',
    STREAM_LANDING: 'HA_PTA_SLP_StreamLanding',
    DISCOVERY_PROPERTY_FEED: 'HA_PTA_LANDING_DiscoveryfeedSLPs',
    PRE_BRAND_TRANSITION: 'HA_GX_PRE_BRAND_TRANSITION',
    POST_BRAND_TRANSITION: 'HA_GX_POST_BRAND_TRANSITION',
    DISCOVERY_DESTINATIONS: 'HA_PTA_LANDING_DestinationDiscoveryfeedSLPs',
    SLP_TRAFFIC_TEST_AA: 'HA_PTA_LANDING_SLPTrafficTestAA',
    SLP_TOP_X_BEST_META_TITLE_TRAFFIC_TEST: 'HA_PTA_LANDING_SLPTopXBestMetaTitleTrafficTest',
    BREADCRUMB_IN_HEADER: 'HA_PTA_LANDING_SLPReduceAndRepositionBreadcrumb',
    HA_TYPEAHEAD_LID_SEARCH: 'HA_TYPEAHEAD_LID_SEARCH',
    HA_TYPEAHEAD_TWO_LINE_DISPLAY: 'ha_typeahead_two_line_display',
    MAP_PROPERTIES_REDESIGN_MOBILE: 'HA_PTA_LANDING_MapPropertiesRedesignMobile',
    MAP_PROPERTIES_REDESIGN_DESKTOP: 'HA_PTA_LANDING_MapPropertiesRedesignDesktop',
    SEARCH_FORM_SLP: 'HA_PTA_SEARCHFORM_SLP_V2',
    SEARCH_FORM_MLP: 'HA_PTA_SEARCHFORM_MLP_V2',
    TRIPBOARDS_SAVE_LABEL: 'HA_PTA_LANDING_TripBoardsSaveLabel',
    ABOVE_FOLD_REDESIGN: 'HA_PTA_LANDING_SLPAboveFoldRedesign',
    DATELESS_RANKING: 'HA_PTA_LANDING_DatelessRanking',
    LANDING_NEW_HEADINGS: 'HA_PTA_LANDING_NewHeadings',
    HA_PTA_HEADER_LOGIN_COPY: 'HA_PTA_HEADER_LOGIN_COPY',
    DYNAMIC_SEO_INTRO_PARAGRAPH: 'HA_PTA_LANDING_SLPDynamicIntroParagraph',
    DYNAMIC_RENDERING_2: 'HA_PTA_LANDING_DynamicRenderingIteration2',
    SEARCH_HISTORY_LINK_TO_PDP: 'HA_PTA_LANDING_SearchHistoryLinkingtoPDPonSLP',
    DESTINATION_REFINEMENTS_SLP_DESKTOP: 'HA_PTA_LANDING_DynamicRefinementsSLPDesktop',
    DESTINATION_REFINEMENTS_SLP_MOBILE_TABLET: 'HA_PTA_LANDING_DynamicRefinementsSLPMobileTablet',
    NO_GEO_FENCE_SEARCH_HISTORY: 'HA_PTA_LANDING_NoGeoFenceSearchHistorySLP',
    OPTIMIZED_PROPERTY_CARD_CONTENT: 'HA_PTA_LANDING_OptimizedPropertyCardContent',
    HA_TRAVELER_SAME_DAY_BOOKINGS: 'HA_TRAVELER_SAME_DAY_BOOKINGS', // 34821
    SLP_SERVER_SIDE_REVIEWS: 'HA_PTA_LANDING_SLPServerSideReviews',
    SEARCH_FORM_SLP_DATE_PICKER_OPENED: 'HA_PTA_SEARCHFORM_SLP_Datepickeropened',
    HA_PTA_LANDING_SLP_H2_HEADINGS: 'HA_PTA_LANDING_SLPH2Headings',
    HA_PTA_LANDING_COVID19_ON_SLP: 'HA_PTA_LANDING_COVID19onSLP'
};

export const EVALUATE = [
    TESTS.GDPR,
    TESTS.REDESIGN_QA_SEO_TEXT,
    TESTS.POLYFILL_SERVICE,
    TESTS.PROPERTY_TYPE_NAME_LISTING_CARDS,
    TESTS.STREAM_LANDING,
    TESTS.DISCOVERY_PROPERTY_FEED,
    TESTS.PRE_BRAND_TRANSITION,
    TESTS.POST_BRAND_TRANSITION,
    TESTS.DISCOVERY_DESTINATIONS,
    TESTS.BREADCRUMB_IN_HEADER,
    TESTS.HA_TYPEAHEAD_LID_SEARCH,
    TESTS.HA_TYPEAHEAD_TWO_LINE_DISPLAY,
    TESTS.MAP_PROPERTIES_REDESIGN_MOBILE,
    TESTS.MAP_PROPERTIES_REDESIGN_DESKTOP,
    TESTS.SEARCH_FORM_SLP,
    TESTS.SEARCH_FORM_MLP,
    TESTS.TRIPBOARDS_SAVE_LABEL,
    TESTS.ABOVE_FOLD_REDESIGN,
    TESTS.DATELESS_RANKING,
    TESTS.LANDING_NEW_HEADINGS,
    TESTS.HA_PTA_HEADER_LOGIN_COPY,
    TESTS.DYNAMIC_SEO_INTRO_PARAGRAPH,
    TESTS.DYNAMIC_RENDERING_2,
    TESTS.SEARCH_HISTORY_LINK_TO_PDP,
    TESTS.DESTINATION_REFINEMENTS_SLP_DESKTOP,
    TESTS.DESTINATION_REFINEMENTS_SLP_MOBILE_TABLET,
    TESTS.NO_GEO_FENCE_SEARCH_HISTORY,
    TESTS.OPTIMIZED_PROPERTY_CARD_CONTENT,
    TESTS.HA_TRAVELER_SAME_DAY_BOOKINGS,
    TESTS.SLP_SERVER_SIDE_REVIEWS,
    TESTS.SEARCH_FORM_SLP_DATE_PICKER_OPENED,
    TESTS.HA_PTA_LANDING_SLP_H2_HEADINGS,
    TESTS.HA_PTA_LANDING_COVID19_ON_SLP
];

export const hasTest = (abacus, test) => !!(abacus && abacus[test]);

export const getValue = (abacus, test) => {
    return hasTest(abacus, test) ?
        abacus[test].value :
        null;
};
